import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnInit,
  ComponentRef,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UiService } from "src/app/ui/ui.service";
import {
  FlowNodeController,
  cacheReadyOperator,
} from "../../flow-node.controller";
import { FlowsService } from "../../flows.service";
import { PhoneNodeMenuComponent } from "./phone-node-menu/phone-node-menu.component";

@Component({
  selector: "app-phone-node",
  templateUrl: "./phone-node.component.html",
  styleUrls: ["./phone-node.component.scss"],
})
export class PhoneNodeComponent extends FlowNodeController implements OnInit {
  menuComponent?: ComponentRef<PhoneNodeMenuComponent>;
  icon!: string;
  constructor(
    factoryResolver: ComponentFactoryResolver,
    ViewContainerRef: ViewContainerRef,
    FlowsService: FlowsService,
    Router: Router,
    uiService: UiService,
    MatDialog: MatDialog,
  ) {
    super(
      factoryResolver,
      ViewContainerRef,
      FlowsService,
      Router,
      uiService,
      MatDialog,
    );
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    this.icon = this.node.is_follow_up
      ? "assets/svg/flows/phone-follow-up.svg"
      : "assets/svg/flows/phone.svg";

    forkJoin([
      this.FlowsService.phoneCacheReady.pipe(cacheReadyOperator()),
    ])
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        const factory = this.factoryResolver.resolveComponentFactory(
          PhoneNodeMenuComponent,
        );
        this.menuComponent = factory.create(
          this.flowMenuViewContainerRef.parentInjector,
        );
        this.menuComponent.instance.node = this.node;
        this.menuComponent.instance.selected = this.selected;
        this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;

        this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);
        this.menuComponent.instance.onNodeMenuInstantiated
          .pipe(takeUntil(this.onComponentDestroy))
          .subscribe(() => {
            this.onMenuInstantiated.next();
            this.onMenuInstantiated.complete();
            this.onNodeReady.emit(this.componentRef);
          });
      });

    this.FlowsService.initPhoneNodeCache();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  get flowDTO() {
    return this.menuComponent?.instance.flowDTO;
  }
}
